module.exports = __webpack_public_path__ + "img/edge_activites_junior.4fd60cf6.svg";